import React from 'react';

import me from './me.jpg';
import './Home.css';

const Home = () => {
  return (
    <div>
      <div className="background-image">
        <h1 className="heading">Software engineer</h1>
        <p><a href="/about-me"><button className="btn btn-large">Nice to meet you!</button></a></p>
      </div>
      <br></br>
      <div className="ui raised very padded text container">
        <img className="ui centered large image circular" src={me} alt="leiden-city"/>
        <p></p>
        <p>I discovered my <b>passion</b> for computers at the age of 10, playing on the computer of my grandfather, I don’t remember the model of the computer, just that I had to use 5 1⁄4 floppy disks and set some commands to play a few games.</p>
        <p>I started working as a helpdesk when I was 18 years old maintaining servers and networks until I 'fell in love' with <b>coding</b> at the age of 21.</p>
        <p>My passion brought me to invest myself in years of working <b>full time as a developer</b> while studying <b>part time</b> my <b>software engineering degree</b> until finally, I achieved my goal of graduating.</p>
        <p><b>Always</b> trying my best to improve and to to keep learning every day.</p>
      </div>
      <br></br>
    </div>
  )
}

export default Home;